/**
 * Created by Robert on 2016-12-04.
 *
 * Service for keeping track of and allowing access to the etiketts throughout the app
 */
import {Injectable,Output, EventEmitter} from '@angular/core';
import {TranslateService} from "./translate.service";
import { saveAs } from 'file-saver';

var $ = window['$'];
@Injectable()
export class EtikettService {
	@Output() reset = new EventEmitter();
	public debug:boolean = false;
	private busy:boolean = false;
	public mode:string = 'create';
	public shape:string = 'default';
	public host:string = "";
	public server:string = "";
	public aspxFile = "etikettmaskinen.aspx";

	public largeCountString:string;
	public largeSizeString:string;
	public mediumCountString:string
	public mediumSizeString:string;
	public smallCountString:string;
	public smallSizeString:string;

	private project: any = {
		uuid:'',
		size:'large',
		etiketter:[]
	}
	imageCount: any = {
	};

	public labelCategories:Array<string>=[];
	constructor(private translate:TranslateService){}
	// Generate an uuid (for saving projects mainly).
	private generateUUID(){
		var d = new Date().getTime();
		if(window.performance && typeof window.performance.now === "function"){
			d += performance.now(); //use high-precision timer if available
		}
		var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = (d + Math.random()*16)%16 | 0;
			d = Math.floor(d/16);
			return (c=='x' ? r : (r&0x3|0x8)).toString(16);
		});
		return uuid;
	}

	public setBusy(busy:boolean) : void {
		this.busy = busy;
		if(this.busy) {
			$('body').bind('touchmove', function(e){
				e.stopPropagation();
			})
		} else {
			$('body').unbind('touchmove')
		}
	}

	public initShape(shape:string) {
		switch(shape) {
			case 'bordsplacering':	// Only large
			this.setPrintSize('large');
			this.largeCountString = '4 stycken';
			this.largeSizeString = '10x14 cm';
			break;
			case 'flasketikett':	// Only large
			this.setPrintSize('medium');
			this.mediumCountString = '8 stycken';
			this.mediumSizeString = '9x5 cm';
			break;
			case 'locketikett':		// Large and medium
			if(this.getPrintSize() === 'small') {
				this.setPrintSize('medium');
			}

			this.largeCountString = '2 stycken';
			this.largeSizeString = '15x15 cm';
			this.mediumCountString = '3 stycken';
			this.mediumSizeString = '12x12 cm';

			break;
			default:
			this.largeCountString = '4 stycken';
			this.largeSizeString = '10x14 cm';
			this.mediumCountString = '8 stycken';
			this.mediumSizeString = '10x7 cm';
			this.smallCountString = '16 stycken';
			this.smallSizeString = '5x7 cm';
			break;
		}
	}
	public setShape(shape:string) : void {
		
		var _this = this;
		this.getLabelCount(shape).then(function() {
			_this.shape = shape;
			_this.initShape(shape);
			_this.createEtikettProject(_this.project.uuid);
		},function(err) {

		});
//		this.createEtikettProject();
	}

	public isBusy() {
		return this.busy;
	}
	// Convert json object into string
	public getJson():string {
		return JSON.stringify(this.project);
	}

	public getLabelCount(shape?:string) : Promise<any> {

		if(!shape) {
			shape = this.shape;
		}
		var _this = this;
		_this.labelCategories = [];
		return new Promise(function(resolve,reject) {
			$.ajax({
				type: "POST",
				url: _this.aspxFile+"/GetImageCount",
				contentType: "application/json; charset=utf-8",
				data:'{type:"'+shape+'"}',
				dataType: "json",

				success: function (response: any) {
					try {
						
						var count = JSON.parse(response.d);
						_this.imageCount = count;
						for(var c in _this.imageCount) {
							_this.labelCategories.push(c);
						}
						_this.shape = shape;
					}catch(e) {
						console.log("e ",e);
					}
					resolve();
				},
				failure: function (response: any) {
					reject();
				}
			});
		});

	}
	// Called by template
	public getPrintSize():string {
		return this.project['size'];
	}

	public setPrintSize(size:string) {
		this.project['size']=size;
	}

	// Called by template
	public getEtiketter():any {
		return this.project.etiketter;
	}

	public sendMail(from:string,to:string,subject:string,message:string):void {
		this.setBusy(true);
		var _this = this;
		var uuid = this.project.uuid;

		var data = {
			uuid:uuid,
			from:this.translate.translate('info@nordicsugar.com'),
			to: to,
			subject: this.translate.translate('mail-subject'),
			body:this.translate.translate('mail-message')
		}

		_this.saveEtikettProject().then(function(){
		$.ajax({
			type:"POST",
			url: _this.aspxFile+"/SendMail",
			data: '{json: ' + JSON.stringify(data) + ' }',
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			success:function(response:any) {
				_this.setBusy(false);

			},
			failure:function(response:any) {
				_this.setBusy(false);
				console.warn("Mailfail ",response);
			}
		})},function() {

		})
	}
	public createPDF(uuid?:string):Promise<any> {
		var _this = this;

		if(!uuid) {
			uuid = this.project.uuid;
		}

		return new Promise(function(resolve,reject) {
			_this.saveEtikettProject().then(function(){
				$.ajax({
					type: "POST",
					url: _this.aspxFile+"/CreatePDF",
					data: '{uuid: "' + uuid + '" }',
					contentType: "application/json; charset=utf-8",
					dataType: "json",

					success: function (response: any) {
						console.log("create success");
						resolve(response.d);
					},
					failure: function (response: any) {
						reject(response.d);
					}
				});
			},function(err) {
				reject(err);
			})
		});

	}

	// Save the current project
	public saveEtikettProject():Promise<any> {
		var instance = this;
		var json = this.getJson();
		return new Promise(function (resolve, reject) {
			$.ajax({
				type: "POST",
				url: instance.aspxFile+"/SaveEtikettProject",
				data: '{json: ' + json + ' }',
				contentType: "application/json; charset=utf-8",
				dataType: "json",

				success: function(response:any) {
					resolve();
				},
				failure: function(response:any) {
					reject(response.d);
				}
			});

		});

	}

	public loadEtikettProject(uuid:string) : Promise<any> {
		
		var _this = this;
		return new Promise(function(resolve,reject) {
			$.ajax({
				type: "POST",
				url: _this.aspxFile+"/LoadEtikettProject",
				data: '{uuid: "' + uuid + '" }',
				contentType: "application/json; charset=utf-8",
				dataType: "json",

				success: function(response:any) {
					if(response.d) {
						var proj = JSON.parse(response.d);
						if(!proj.shape) {
							proj.shape = 'default';
						}
						_this.getLabelCount(proj.shape).then(function() {
							_this.project = proj;
							_this.initShape(proj.shape);
							resolve();
						},function(err) {
							reject(err);
						})
					} else {
						reject("File not found");
					}
				},
				failure: function(response:any) {
					reject(response.d);
				}
			})
		});
	}

	public createEtikettProject(uuid?:string):string {
		
		if(uuid) {
			this.project.uuid = uuid;
		} else {
			this.project.uuid = this.generateUUID();
			this.shape = 'default';
		}
			// Default
		this.project.etiketter = [];
		this.project.shape = this.shape;
		this.initShape(this.shape);
		if(this.shape === 'locketikett') {
			
			this.project.etiketter.push({image:0,open:false,label:"",mode:this.labelCategories[0], font:'plain',count:1,fontSize:'24'});
		} else {
			this.project.etiketter.push({image:0,open:false,label:"",mode:this.labelCategories[0], font:'plain',count:1,fontSize:'40'});
		}
		this.open(this.project.etiketter.length-1);
		return this.project.uuid;
	}

	public addEtikett() {
		if(this.shape === 'locketikett') {
			this.project.etiketter.push({image:0,open:false,label:"",mode:this.labelCategories[0], font:'plain',count:1,fontSize:'24'});
		} else {
			this.project.etiketter.push({image:0,open:false,label:"",mode:this.labelCategories[0], font:'plain',count:1,fontSize:'40'});
		}
		this.open(this.project.etiketter.length-1);
		this.saveEtikettProject();
	}

	public removeEtikett(index:number) {
		this.project.etiketter.splice(index,1)
		this.saveEtikettProject();
	}

	public getEtikett(index:number):any {
		return this.project.etiketter[index];
	}

	public isOpen(index:number):boolean {
		return this.project.etiketter[index]['open'];
	}

	public open(index:number) {
		if(!this.project.etiketter[index]['open']) {
			for(var i = 0; i < this.project.etiketter.length;i++) {
				this.project.etiketter[i]['open'] = false;
			}
			this.project.etiketter[index]['open'] = true;
		}
	}
	public toggleOpen(index:number) {
		if(!this.project.etiketter[index]['open']) {
			for(var i = 0; i < this.project.etiketter.length;i++) {
				this.project.etiketter[i]['open'] = false;
			}
		}
		this.project.etiketter[index]['open'] = !this.project.etiketter[index]['open'];
	}
}


// WEBPACK FOOTER //
// ./app/services/etikett.service.ts